import { useEffect, useState } from "react";
import { projectedTrackedDurationSeconds } from "../domain/executionUi";

export const LIVE_DURATION_REFRESH_MS = 1000;

function currentTime() {
  return Date.now();
}

function scheduleInterval(callback, delay) {
  return setInterval(callback, delay);
}

function cancelInterval(intervalId) {
  clearInterval(intervalId);
}

export default function useLiveExecutionDuration(record, enabled, {
  documentObject = typeof document === "undefined" ? null : document,
  now = currentTime,
  setIntervalFn = scheduleInterval,
  clearIntervalFn = cancelInterval,
} = {}) {
  const [nowMs, setNowMs] = useState(() => now());
  const active = Boolean(enabled && record?.document?.status === "ACTIVE");

  useEffect(() => {
    if (!active) return undefined;

    let intervalId = null;

    function stop() {
      if (intervalId != null) clearIntervalFn(intervalId);
      intervalId = null;
    }

    function refresh() {
      setNowMs(now());
    }

    function start() {
      stop();
      if (documentObject?.visibilityState === "hidden") return;
      refresh();
      intervalId = setIntervalFn(refresh, LIVE_DURATION_REFRESH_MS);
    }

    function handleVisibilityChange() {
      start();
    }

    start();
    documentObject?.addEventListener?.("visibilitychange", handleVisibilityChange);
    return () => {
      stop();
      documentObject?.removeEventListener?.("visibilitychange", handleVisibilityChange);
    };
  }, [active, clearIntervalFn, documentObject, now, setIntervalFn]);

  return projectedTrackedDurationSeconds(record, nowMs);
}
